import React, { Fragment } from "react";
import VideoGallery from "./videoGallery";
import "./reels.scss";

export default () => (
  <div>
    <VideoGallery />
  </div>
);
